/**
 * @file 错题本store
 */
import Vue from 'vue';
import Vuex from 'vuex';
import server from '@/pages/pano-game/service';

Vue.use(Vuex);

const state = {
    noteList: []
};

const mutations = {
    setNoteList(state, data) {
        state.noteList = data || [];
    }
};
const getters = {
};
const actions = {
    getNoteList: ({commit}) => {
        return server('getWrongQuestion').then(res => {
            if (res && res.errno === 0 && res.data) {
                commit('setNoteList', res.data);
                return res;
            }
            throw new Error(res.errstr || 'getwrongquestion 数据结构异常');
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};